import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import FormInput from '../../../../commonComponents/forms/FormInput';
import DateRange from '../../../../commonComponents/forms/inputs/DateRange';
import LoggedUserContext from '../../../../contextProviders/LoggedUserContext';
import ConfigsContext from '../../../../contextProviders/ConfigsContext';
import translate from '../../../../commonComponents/translate';

function CareerFilters(props) {
  const { loggedUser } = useContext(LoggedUserContext);
  const { organization } = useContext(ConfigsContext);
  const { directSelling } = organization;
  const { _id: loggedUserId } = loggedUser;
  const { t, filters, onFilterChange, onDateChange = [] } = props;
  const { user, userNumber, startDate, endDate } = filters;

  const inputProps = useCallback(
    field => {
      switch (field) {
        case 'user':
          return {
            allowClear: true,
            url: '/user/table/network/list',
            filterUrl: '/user/table/network/list',
          };
        default:
          return {
            items: [],
          };
      }
    },
    [loggedUserId],
  );

  const dateRanges = {
    [t('dateRange_thisWeek')]: [
      moment().utc().startOf('isoWeek').valueOf(),
      moment().utc().endOf('day').valueOf(),
    ],
    [t('dateRange_lastWeek')]: [
      moment().utc().subtract(1, 'week').startOf('isoWeek'),
      moment().utc().subtract(1, 'week').endOf('isoWeek'),
    ],
    [t('dateRange_twoWeeksAgo')]: [
      moment().utc().subtract(2, 'week').startOf('isoWeek'),
      moment().utc().subtract(2, 'week').endOf('isoWeek'),
    ],
    [t('dateRange_threeWeeksAgo')]: [
      moment().utc().subtract(3, 'week').startOf('isoWeek'),
      moment().utc().subtract(3, 'week').endOf('isoWeek'),
    ],
    [t('dateRange_fourWeeksAgo')]: [
      moment().utc().subtract(4, 'week').startOf('isoWeek'),
      moment().utc().subtract(4, 'week').endOf('isoWeek'),
    ],
  };

  return (
    <div className="filters-wrapper">
      <div className="career-filter-container">
        <FormInput
          id="user"
          value={user}
          name="user"
          disabled={false}
          placeholder={t('user')}
          type="users"
          onChange={onFilterChange('user')}
          inputProps={inputProps('user')}
        />
      </div>
      <div className="career-filter-container">
        <FormInput
          id="userNumber"
          value={userNumber}
          name="userNumber"
          disabled={false}
          placeholder={t('profile.userNumber')}
          type="text"
          onChange={onFilterChange('userNumber')}
          inputProps={inputProps('userNumber')}
        />
      </div>
      <div className="career-filter-container">
        <DateRange
          directSellingSettings={directSelling}
          id="dateRange"
          placeholder={t('report.arcova.searchDate')}
          startDate={startDate}
          endDate={endDate}
          onChange={({ startDate: sDate, endDate: eDate }) =>
            onDateChange(sDate, eDate)
          }
          onClear={() => onDateChange(null, null)}
          customRanges={dateRanges}
        />
      </div>
    </div>
  );
}

CareerFilters.propTypes = {
  t: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  onDateChange: PropTypes.func.isRequired,
  filters: PropTypes.shape({
    user: PropTypes.string,
    userNumber: PropTypes.string,
    startDate: PropTypes.number,
    endDate: PropTypes.number,
  }).isRequired,
};

export default translate(CareerFilters);
